package tta.destinigo.talktoastro.feature_chat_consultation_new.persentation.chat_room_view

sealed class ChatRoomMsgState {
    data object InitialState: ChatRoomMsgState()
    data class ExpertTyping(val isExpertTyping:Boolean): ChatRoomMsgState()
    data class MsgUpdated(val msg:String): ChatRoomMsgState()
}